<script setup lang="ts">
import { ReserveType } from '@utils/itinerary';

const itineraryStore = useItineraryStore();
const { isSelectingReturn, expectedPackagesToBeSelected } =
    storeToRefs(itineraryStore);
const searchFormStore = useSearchFormStore();
const { reserveType } = storeToRefs(searchFormStore);

const packageSelectStore = usePackageSelectStore();
const { deselectPackage } = packageSelectStore;
const { selectedPackages } = classToRefs(packageSelectStore);

const flightForm = useFlightForm();
const { isDomestic } = moduleToRefs(flightForm);

const showTicketHelper = computed(() => {
    if (expectedPackagesToBeSelected.value === 2) {
        return !(reserveType.value === ReserveType.Flight && !isDomestic.value);
    }
    return false;
});

const changeReserve = () => deselectPackage(selectedPackages.value.length - 1);
</script>
<template>
    <div v-if="showTicketHelper" class="choose-ticket">
        <h2>
            {{ `بلیط ${isSelectingReturn ? 'برگشت' : 'رفت'} را انتخاب کنید.` }}
        </h2>
        <mr-button
            v-if="isSelectingReturn"
            class="change-ticket-button"
            @click="changeReserve"
        >
            تغییر بلیط رفت
        </mr-button>
    </div>
</template>
<style scoped lang="scss">
.choose-ticket {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 0;
    h2 {
        font-size: 18px;
        margin: 0;
        color: usePalette($p-cool-gray, $p-800);
    }
    .change-ticket-button {
        flex-basis: content;
    }
}
</style>
